module.exports = __webpack_public_path__ + "static/media/food-truck-line-share.c393d491.png";